import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

// Import environment
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransferService {

  constructor(private http: HttpClient) { }

  getAllDeposit = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/depositList', { params })
  }


  getAllDepositDoc = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/depositList', { params, responseType: 'text' as 'json' })
  }


  getAllWithdraw = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/withdrawList', { params })
  }

  getAllWithdrawDoc = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/withdrawList', { params, responseType: 'text' as 'json' })
  }

  findByIdDeposit = (id: string) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/deposit/find-id/' + id)
  }

  findByIdWithdraw = (id: string) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/withdraw/find-id/' + id)
  }

  getFiatDeposits(Id: any, token:any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token
    });

    const params = new HttpParams()
      .set('_id', Id)
      .set('page', 1)
      .set('limit', 10);


    return this.http.get(environment.walletApiUrl +`api/admin/fiatDepositForBuyCoinList`, { headers, params });
  }

  approveFiatDeposit = (data: any) => {
    return this.http.post(environment.walletApiUrl + 'api/admin/fiatDeposit/approve', data)
  }

  rejectFiatDeposit = (data: any) => {
    return this.http.post(environment.walletApiUrl + 'api/admin/fiatDeposit/reject', data)
  }

  approveFiatWithdraw = (id: string) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/fiatWithdraw/approve/' + id,)
  }

  rejectFiatWithdraw = (data: any) => {
    return this.http.post(environment.walletApiUrl + 'api/admin/fiatWithdraw/reject', data)
  }
  cancelFiatWithdraw = (data: any) => {
    return this.http.post(environment.walletApiUrl + 'api/admin/fiatWithdraw/cancel', data)
  }
  pendingFiatWithdraw = (data: any) => {
    return this.http.post(environment.walletApiUrl + 'api/admin/fiatWithdraw/pending', data)
  }


  
  approveCoinWithdraw = (id: string) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/coinWithdraw/approve/' + id,)
  }

  approveRejectDeposit(depositId: string, status: string , description:any  ,token:any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': token
    })

    // Use HttpParams to create URL-encoded data
    let body = new HttpParams()
      .set('depositId', depositId)
      .set('status', status)
      .set('description', description)

    return this.http.put(environment.walletApiUrl +`api/admin/fiatDepositForBuyCoinList/approveReject`, body.toString(), { headers });
  }
  apiUrl(apiUrl: any, arg1: string, arg2: { headers: HttpHeaders; }): Observable<any> {
    throw new Error('Method not implemented.');
  }

  rejectCoinWithdraw = (data: any) => {
    return this.http.post(environment.walletApiUrl + 'api/admin/coinWithdraw/reject', data)
  }


  nearMallsApiForCommision(phoneNo: any, amount: any, transactionId: any,  coinCurrentPrice:any ): Observable<any> {


   console.log("the phone mumver" , phoneNo);

    const formData = new FormData();

    formData.append('MobileNumber', phoneNo);  // Updated key here
    formData.append('Amount', amount);
    formData.append('TransactionHash', transactionId);
    formData.append('CoinLivePrice', coinCurrentPrice);



    return this.http.post(`https://credapi.nearmalls.com/api/NearShopApi/CredBullCommission`, formData);
  }

  approveWithdrawStake(depositId: string, withdrawStatus: string ,token:any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': token
    })

    // Use HttpParams to create URL-encoded data
    let body = new HttpParams()
      .set('depositId', depositId)
      .set('withdrawStatus', withdrawStatus)

    return this.http.put(environment.walletApiUrl +`api/admin/approveAndReleaseStakedCoins`, body.toString(), { headers });
  }
}
